import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=0a444094&"
import script from "./BasicInfo.vue?vue&type=script&lang=ts&"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports